import { create } from 'zustand';

import { OpenCallService } from '@/services';
import { OpenCallModel } from '@repo/ui/models/open-call';
import { createInitialState, InitialState } from '@repo/ui/state';

const initialState = createInitialState<OpenCallModel | undefined>(undefined);

export interface OpenCallState extends InitialState<OpenCallModel | undefined> {
  requestedId?: string;
  fetchOpenCall: (id: string) => Promise<void>;
  resetOpenCall: () => void;
}

export const store = create<OpenCallState>((set, get) => ({
  ...initialState,
  requestedId: undefined,

  resetOpenCall: () =>
    set((state) => ({
      ...state,
      ...initialState,
      requestedId: undefined,
    })),

  fetchOpenCall: async (id) => {
    set((state) => ({
      ...state,
      error: null,
      loading: true,
      requestedId: id,
    }));

    try {
      const data = await OpenCallService.byId(id);
      if (get().requestedId !== id) return;

      set((state) => ({
        ...state,
        data,
        error: data ? null : 'Open call not found',
      }));
    } catch (error: unknown) {
      if (get().requestedId !== id) return;

      set((state) => ({
        ...state,
        error: (error as Error).message,
      }));
    } finally {
      if (get().requestedId === id) {
        set((state) => ({ ...state, loading: false }));
      }
    }
  },
}));
